<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="2" />
    <h4 class="mb-4">Referencias Médicas por Fecha</h4>
    <hr>

    <!--  Botones de rango rápido  -->
    <div class="mb-3 d-flex flex-wrap gap-2">
      <button class="btn btn-outline-primary"   @click="setDateRange(getToday)">Hoy</button>
      <button class="btn btn-outline-danger"    @click="setDateRange(getThisWeek)">Semana Actual</button>
      <button class="btn btn-outline-secondary" @click="setDateRange(getThisMonth)">Mes Actual</button>
      <button class="btn btn-outline-success"   @click="setDateRange(getThisQuarter)">Trimestre Actual</button>
      <button class="btn btn-outline-info"      @click="setDateRange(getThisSemester)">Semestre Actual</button>
      <button class="btn btn-outline-warning"   @click="setDateRange(getThisYear)">Año Actual</button>
    </div>

<!--  Selector de fechas  -->
<div class="fecha-bar mb-3">
  <div class="fecha-campo">
    <label class="form-label">Desde</label>
    <input type="date" class="form-control form-control-sm" v-model="fechaDesde">
  </div>
  <div class="fecha-campo">
    <label class="form-label">Hasta</label>
    <input type="date" class="form-control form-control-sm" v-model="fechaHasta">
  </div>
  <button class="btn btn-dark btn-icono" @click="fetchReferencias()">
    <span class="material-symbols-outlined">search</span>
    Consultar
  </button>
</div>

    <!--  DataTable  -->
    <DataTable
      :data="referencias"
      :columns="columnas"
      idField="idReferencia"
      :acciones="false"
      :mostrarBotonTodos="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonExcel="true"
      mensajeVacio="No hay referencias para el rango de fechas seleccionado."
      @refresh="fetchReferencias()"
    >
      <!-- Fecha formateada -->
      <template #cell-fechaRef="{ row }">
        {{ getFormattedDate(row.fechaRef) }}
      </template>

      <!-- Estado con badge -->
      <template #cell-estado="{ row }">
        <span class="badge-estado" :class="row.estado === 1 ? 'activa' : 'inactiva'">
          {{ row.estado === 1 ? 'Activa' : 'Inactiva' }}
        </span>
      </template>
    </DataTable>

    <Footer />
  </div>
</template>

<script>
import Layout    from '@/components/Layout.vue'
import Footer    from '@/components/Footer.vue'
import DataTable from '@/components/DataTable.vue'
import dateFormat from '@/modules/dateFormat.js'
import api        from '@/services/api'
import Swal       from 'sweetalert2'
import {
  getToday, getThisWeek, getThisMonth,
  getThisQuarter, getThisSemester, getThisYear,
} from '@/modules/queryDateUtils.js'

export default {
  name: 'ReferenciasPorFecha',
  components: { Layout, Footer, DataTable },

  data() {
    return {
      fechaDesde:  '',
      fechaHasta:  '',
      referencias: [],

      getToday, getThisWeek, getThisMonth,
      getThisQuarter, getThisSemester, getThisYear,

      columnas: [
        { field: 'idReferencia',    label: 'ID Referencia' },
        { field: 'fechaRef',        label: 'Fecha de Referencia' },
        { field: 'hora',            label: 'Hora' },
        { field: 'pacienteNombre',  label: 'Paciente' },
        { field: 'cedula',          label: 'Cédula' },
        { field: 'motivoRefNombre', label: 'Motivo de Referencia' },
        { field: 'empresaOrigen',   label: 'Empresa Origen' },
        { field: 'resumen',         label: 'Resumen' },
        { field: 'estado',          label: 'Estado' },
      ],
    }
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos()
    this.$refs.layoutRef.toggleReportes()
    this.$refs.layoutRef.toggleParametros()
    this.$refs.layoutRef.toggleAyuda()
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date)
    },

    setDateRange(getRangeFunction) {
      const { fechaDesde, fechaHasta } = getRangeFunction()
      this.fechaDesde = fechaDesde
      this.fechaHasta = fechaHasta
      this.fetchReferencias()
    },

    validarFechas() {
      if (!this.fechaDesde || !this.fechaHasta) {
        Swal.fire({
          icon: 'warning',
          title: 'Campos requeridos',
          text: 'Debe seleccionar las fechas desde y hasta.',
          confirmButtonText: 'Aceptar',
        })
        return false
      }
      return true
    },

    fetchReferencias() {
      if (!this.validarFechas()) return
      const idEmpresa = window.sessionStorage.getItem('idEmpresa')
      api.get('/vwreferencias/origen-por-fecha', {
        params: { idEmpresa, fechaDesde: this.fechaDesde, fechaHasta: this.fechaHasta },
      })
      .then(response => { this.referencias = response.data })
      .catch(error   => console.error('Error fetching referencias:', error))
    },
  },
}
</script>

<style src="@/assets/css/fechaBar.css" scoped></style>
<style scoped>
.badge-estado {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 0.8rem;
  font-weight: 600;
}
.activa   { background-color: #a5d6a7; }
.inactiva { background-color: #e0e0e0; }
</style>